<template>
  <rpm-input
    type="number"
    :label="!noLabel ? question.label:''"
    :required="!noLabel ? question.required:''"
    :optional="!noLabel ? !question.required:''"
    class="w-full"
    :maxFractionDigits="5"
  ></rpm-input>
</template>

<script>
export default {
  name: "NumberAnswer",
  props: {
    question: {
      type: Object,
      required: true
    },
    noLabel: {
      type: Boolean,
      default: false
    },
  },
};
</script>
